"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserData = exports.loginUserandGetData = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var actions = _interopRequireWildcard(require("../constants"));

var _index = require("./index");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var loginProcessRequest = function loginProcessRequest() {
  return {
    type: actions.LOG_IN_PROCESS_REQUEST
  };
};

var loginProcessSuccess = function loginProcessSuccess() {
  return {
    type: actions.LOG_IN_PROCESS_SUCCESS
  };
};

var loginProcessFailure = function loginProcessFailure() {
  return {
    type: actions.LOG_IN_PROCESS_FAILURE
  };
};

var userRetrievalRequest = function userRetrievalRequest() {
  return {
    type: actions.USER_DATA_RETRIEVAL_REQUEST
  };
};

var userRetrievalSuccess = function userRetrievalSuccess() {
  return {
    type: actions.USER_DATA_RETRIEVAL_SUCCESS
  };
};

var userRetrievalFailure = function userRetrievalFailure() {
  return {
    type: actions.USER_DATA_RETRIEVAL_FAILURE
  };
};

var loginUserandGetData = function loginUserandGetData(email, password, productId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch(loginProcessRequest());
              _context.next = 4;
              return dispatch((0, _index.logIn)(email, password));

            case 4:
              _context.next = 6;
              return dispatch((0, _index.loadUserOrganisations)());

            case 6:
              _context.next = 8;
              return dispatch((0, _index.loadUserTeams)());

            case 8:
              _context.next = 10;
              return dispatch((0, _index.loadUserProducts)());

            case 10:
              if (!productId) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return dispatch((0, _index.loadUserFeatureAccess)(productId));

            case 13:
              _context.next = 15;
              return dispatch((0, _index.loadUserProductSettings)(productId));

            case 15:
              dispatch(loginProcessSuccess());
              return _context.abrupt("return", true);

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              dispatch(loginProcessFailure());
              return _context.abrupt("return", false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 19]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.loginUserandGetData = loginUserandGetData;

var getUserData = function getUserData(productId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(dispatch, getState) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dispatch(userRetrievalRequest());
              _context2.next = 4;
              return dispatch((0, _index.readUserDetails)());

            case 4:
              _context2.next = 6;
              return dispatch((0, _index.loadUserOrganisations)());

            case 6:
              _context2.next = 8;
              return dispatch((0, _index.loadUserTeams)());

            case 8:
              _context2.next = 10;
              return dispatch((0, _index.loadUserProducts)());

            case 10:
              if (!productId) {
                _context2.next = 15;
                break;
              }

              _context2.next = 13;
              return dispatch((0, _index.loadUserFeatureAccess)(productId));

            case 13:
              _context2.next = 15;
              return dispatch((0, _index.loadUserProductSettings)(productId));

            case 15:
              dispatch(userRetrievalSuccess());
              return _context2.abrupt("return", true);

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](0);
              dispatch(userRetrievalFailure());
              return _context2.abrupt("return", false);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 19]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getUserData = getUserData;